import { IFormField } from '@app/src/common/model/FormField';
import { FieldType } from '@app/src/common/components/form/MobxFieldControl';
import { FormControlType } from '@app/src/common/model/FormControls';

export const SignInFormFields = {
  email: {
    id: 'email',
    name: 'Email',
    label: 'auth.form.email.label'
  },
  password: {
    id: 'password',
    name: 'Password',
    label: 'auth.form.password.label'
  }
};

export const signInFormConfig: IFormField[] = [
  {
    name: 'email',
    label: 'auth.form.email.label',
    type: FieldType.STRING,
    control: FormControlType.INPUT,
    required: true
  },
  {
    name: 'password',
    label: 'auth.form.password.label',
    type: FieldType.STRING,
    control: FormControlType.INPUT,
    required: true
  }
];
